export default {
    checkSpecialCharacter,
    checkEmojisCharacter,
    checkSpecialCharacterForFoldername,
  };
  
  function checkSpecialCharacter() {
    let resultString = ""
    return resultString
  }

  function checkEmojisCharacter() {
    
    return /\p{Emoji}/u;
  }

  function checkSpecialCharacterForFoldername() {
    // const emojiRegex = /^[a-z-A-Z_ก-๙0-9()@#$!+^&=\s]*$/
    const SpecialCharacterRegex = /^((?![<>:*?\\|/"']).)*$/s
    return SpecialCharacterRegex;
  }